module.exports = __webpack_public_path__ + "img/profiles-mobile.ea0c1992.png";